import type { PersonnelCostDepartment } from "@/lib/personnelCosts";
import { PERSONNEL_DEPARTMENT_OPTIONS } from "@/lib/personnelCosts";

interface DepartmentMultiSelectProps {
  label?: string;
  value: PersonnelCostDepartment[];
  onChange: (value: PersonnelCostDepartment[]) => void;
  hint?: string;
  allowEmpty?: boolean;
  emptyLabel?: string;
}

export function DepartmentMultiSelect({
  label = "Abteilungen",
  value,
  onChange,
  hint,
  allowEmpty = true,
  emptyLabel = "Alle Abteilungen",
}: DepartmentMultiSelectProps) {
  function toggle(dept: PersonnelCostDepartment) {
    if (value.includes(dept)) {
      onChange(value.filter((d) => d !== dept));
    } else {
      onChange([...value, dept]);
    }
  }

  return (
    <div className="space-y-1">
      <span className="eh-label">{label}</span>
      {hint ? <p className="text-xs text-label-secondary">{hint}</p> : null}
      <div className="flex flex-wrap gap-2 pt-1">
        {allowEmpty ? (
          <button
            type="button"
            className={`rounded-full border px-3 py-1 text-xs transition ${
              value.length === 0
                ? "border-accent bg-accent-soft text-accent"
                : "border-separator text-label-secondary hover:border-accent/50"
            }`}
            onClick={() => onChange([])}
          >
            {emptyLabel}
          </button>
        ) : null}
        {PERSONNEL_DEPARTMENT_OPTIONS.map((opt) => {
          const active = value.includes(opt.value);
          return (
            <button
              key={opt.value}
              type="button"
              className={`rounded-full border px-3 py-1 text-xs transition ${
                active
                  ? "border-accent bg-accent-soft text-accent"
                  : "border-separator text-label-secondary hover:border-accent/50"
              }`}
              onClick={() => toggle(opt.value)}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function departmentsLabel(departments: PersonnelCostDepartment[] | null | undefined): string {
  if (!departments?.length) return "alle Abteilungen";
  return departments
    .map((d) => PERSONNEL_DEPARTMENT_OPTIONS.find((o) => o.value === d)?.label ?? d)
    .join(", ");
}
